.select {
  .label {
    display: block;
    color: var(--bc-color-text-secondary);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 12px;
    margin-bottom: 9px;
  }

  .tag {
    width: 100%;
  }

  .hideTag {
    display: none;
  }

  :global {
    .ant-select {
      width: 100%;
    }
  }

  &.error {
    :global {
      .ant-select {
        border: 1px solid var(--bc-color-error);
        &:hover, &:active, &:focus {
          border: 1px solid var(--bc-color-error);
        };
      }
    }
  }
}

.sizeFix {
  height: var(--bc-control-height);
}

.sizeFixLG {
  height: var(--bc-control-height-lg);
}

.selectAll {
  margin-bottom: calc(var(--bc-padding-xs) / 2);
  padding: 0 8px;

  .checkboxRoot {
    --bc-control-interactive-size: 16px;
    width: calc(100% - 18px);
  }

  .checkboxLabel {
    width: 100%;
    padding: 9px 8px;
    margin-left: 4px;
    border-radius: var(--bc-border-radius);
    &:hover {
      background-color: var(--bc-tree-select-node-hover-bg);
    }
  }
}

.suffix {
  display: flex;
}

.treeDropdown {
  border-radius: 8px;

  :global {
    .ant-select-tree-checkbox {
      margin-left: 8px;
    }

    .ant-select-tree-switcher {
      order: 1;
    }
  }
}

.treeItem {
  font-size: var(--bc-select-option-font-size);
}

.errorContainer {
  margin-top: 6px;
  font-size: 12px;
  line-height: 12px;
  color: var(--bc-color-error);

  .icon {
    font-size: 13px;
    color: var(--bc-color-error);
    margin-right: 5px;
  }
}
